var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28711 3.75H16.7114C16.8325 3.75 16.951 3.78517 17.0524 3.85124C17.1539 3.9173 17.234 4.01142 17.283 4.12215C17.332 4.23288 17.3477 4.35546 17.3284 4.47498C17.309 4.5945 17.2553 4.70583 17.1739 4.79542L12.0368 10.4462C11.9322 10.5613 11.8743 10.7112 11.8743 10.8666V15.2905C11.8743 15.3934 11.8489 15.4947 11.8003 15.5854C11.7518 15.6761 11.6816 15.7535 11.596 15.8105L9.09595 17.4772C9.00183 17.54 8.89244 17.576 8.77944 17.5814C8.66645 17.5869 8.55409 17.5616 8.45435 17.5082C8.35461 17.4548 8.27123 17.3754 8.2131 17.2784C8.15497 17.1813 8.12427 17.0703 8.12427 16.9572V10.8666C8.12427 10.7112 8.06631 10.5613 7.96173 10.4462L2.82465 4.79542C2.7432 4.70583 2.68953 4.5945 2.67016 4.47498C2.65079 4.35546 2.66655 4.23288 2.71554 4.12215C2.76452 4.01142 2.84462 3.9173 2.94608 3.85124C3.04755 3.78517 3.16603 3.75 3.28711 3.75V3.75Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.094feed54a0789326f8ca14f5b29be25.svg";
export { ForwardRef as ReactComponent };